module.exports = kampaConfiguratorData;


//////////////////
// WEBPACK FOOTER
// external "kampaConfiguratorData"
// module id = 3
// module chunks = 1 2